module.exports = __webpack_public_path__ + "static/media/pousada_3.c3d7f0b2.jpg";